import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('market', ['market']),
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/page-market-detail-sushi/pages/sushi-market-methodology/sushi-market-methodology.js